import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { EntityDetail } from "@/components/EntityDetail";

export default function EntityPage() {
  const { eid } = useParams();
  const { base } = useOutletContext();
  const navigate = useNavigate();
  const go = (id) => navigate(`${base}/lore/${id}`);
  return (
    <div className="lf-reading mx-auto w-full max-w-[1150px] px-4 py-10 sm:px-8 lg:px-14 2xl:max-w-[1500px]" data-testid="entity-page">
      <button onClick={() => navigate(`${base}/lore`)} className="flex items-center gap-1 text-xs text-[#A8A090] hover:text-[#F3EBDD] mb-8" data-testid="entity-back-button">
        <ChevronLeft className="h-3.5 w-3.5" />Lore Bible
      </button>
      <EntityDetail key={eid} entityId={eid} onNavigate={go} onDeleted={() => navigate(`${base}/lore`)} />
    </div>
  );
}
